import { render } from "./RootCause.vue?vue&type=template&id=3fa068d7&scoped=true"
import script from "./RootCause.vue?vue&type=script&lang=js"
export * from "./RootCause.vue?vue&type=script&lang=js"

import "./RootCause.vue?vue&type=style&index=0&id=3fa068d7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa068d7"]])

export default __exports__